export function formatLkr(amount: number | string | null | undefined): string {
  const numericAmount = typeof amount === "string" ? Number(amount.replace(/,/g, "")) : amount;
  const value = typeof numericAmount === "number" && Number.isFinite(numericAmount) ? numericAmount : 0;
  const fractionDigits = Number.isInteger(value) ? 0 : 2;
  const formatter = new Intl.NumberFormat("en-LK", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  return `LKR ${formatter.format(value)}`;
}